class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.drawer = this.querySelector('.size-guide-drawer');
    this.closeBtn = this.querySelector('.size-guide-drawer__close');
    this.overlay = this.querySelector('.size-guide-drawer'); // The container itself acts as overlay

    this.initVisibilityObserver();
    this.bindEvents();
  }

  initVisibilityObserver() {
    // Check if the dropdown already exists
    this.checkDropdownVisibility();

    // Observe body for changes (since the dropdown is injected dynamically)
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.checkDropdownVisibility();
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  checkDropdownVisibility() {
    const dropdown = document.querySelector('.se-type-dropdown');
    const block = this.closest('.js-size-guide-block') || document.querySelector('.js-size-guide-block');

    if (block instanceof HTMLElement) {
      if (dropdown) {
        block.style.display = 'block';
      }

      const optionTitle = document.querySelector('.se-option-title');
      if (optionTitle && !optionTitle.contains(block)) {
        optionTitle.appendChild(block);
        block.style.display = 'block';
      }
    }
  }

  bindEvents() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) {
          this.close();
        }
      });
    }

    // Listen for open events from buttons within the same block
    const block = this.closest('.js-size-guide-block') || document.querySelector('.js-size-guide-block');
    if (block) {
      const trigger = block.querySelector('.js-open-size-guide');
      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.open();
        });
      }
    }
  }

  open() {
    if (this.drawer) this.drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    if (this.drawer) this.drawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);
